module.exports = __webpack_public_path__ + "img/money.ce6b6ec9.png";